"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/serializer"));
__export(require("./src/deserializer"));
//# sourceMappingURL=index.js.map